//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        memberToShow: { type: Object, default: null },
        loadingForm: { type: Boolean, default: false },
        dateConnection: { type: String, default: '' },
    },
}
